import { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Loading,
  Dialog,
  DialogActions,
  DialogContent,
} from "../../../../components";
import {
  notification,
  ConfiguracoesOrdemServicoService,
} from "../../../../services";
import { InputErros } from "../../../../helpers";
import { responseErros, userLogs } from "../../../../utils";

const ConfiguracoesOrdemServicosDialog = ({
  handleCloseDialog,
  openDialog,
}) => {
  const [loading, setLoading] = useState(false);
  const [configuracoes, setConfiguracoes] = useState({
    movimentacaoEstoque: false,
    movimentacaoFinanceira: false,
    serieDocumento: "OS",
  });
  const [userLog, setUserLog] = useState({});
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const configuracoesService = new ConfiguracoesOrdemServicoService();

  useEffect(() => {
    if (openDialog) {
      buscaConfiguracoes();
    }
  }, [openDialog]);

  const buscaConfiguracoes = async () => {
    setLoading(true);
    const { data } = await configuracoesService.getAll();
    setConfiguracoes(data?.[0]);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    e.persist();
    setConfiguracoes((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCheckboxChange = (name) => {
    setConfiguracoes((prev) => ({
      ...prev,
      [name]: !prev?.[name],
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (!configuracoes?.serieDocumento?.trim()) {
      setInputErro(["serieDocumento"]);
      setLoading(false);
      return notification.alertaGenericos("Serie do documento é obrigatório");
    }
    const id = configuracoes?.id;
    let response;
    if (id) {
      response = await configuracoesService.atualizar(id, configuracoes);
    } else {
      response = await configuracoesService.cadastrar(configuracoes);
    }

    setLoading(false);
    setInputErro([]);
    if (!response.isAxiosError) {
      id ? notification.alteracaoSucesso() : notification.cadastroSucesso();
      handleCloseDialog();
    } else {
      responseErros(response);
    }
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(configuracoes);
    setUserLog(logs);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={openDialog}
      onClose={handleCloseDialog}
    >
      <Card className="p-3">
        <CardHeader
          title="Configurações da Ordem de Serviço"
          style={{ textAlign: "center" }}
          userLog={configuracoes?.id ? userLog : null}
          onClickLog={onClickLog}
        />
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <TextField
                id="serieDocumento"
                name="serieDocumento"
                label="Série Documento"
                variant="outlined"
                margin="normal"
                value={
                  configuracoes?.serieDocumento
                    ? configuracoes.serieDocumento
                    : ""
                }
                onBlur={(e) => {
                  const value = e.target.value === "" ? "OS" : e.target.value;
                  setConfiguracoes((prev) => ({
                    ...prev,
                    [e.target.name]: value,
                  }));
                }}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  inputProps: {
                    maxLength: 3,
                    style: { textTransform: "uppercase" },
                  },
                }}
                required
                error={inputErros.get("serieDocumento")}
              />
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <FormControlLabel
                sx={{ pt: 2 }}
                control={
                  <Checkbox
                    checked={configuracoes?.movimentacaoEstoque || false}
                    onChange={() => handleCheckboxChange("movimentacaoEstoque")}
                    color="primary"
                  />
                }
                label="Movimentação de Estoque"
              />
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <FormControlLabel
                sx={{ pt: 2 }}
                control={
                  <Checkbox
                    checked={configuracoes?.movimentacaoFinanceira || false}
                    onChange={() =>
                      handleCheckboxChange("movimentacaoFinanceira")
                    }
                    color="primary"
                  />
                }
                label="Movimentação Financeira"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            id="botaoSalvar"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button
            color="inherit"
            variant="contained"
            onClick={handleCloseDialog}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </DialogActions>
      </Card>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default ConfiguracoesOrdemServicosDialog;
